import { apiFetch } from './http';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5050';

export interface LoyaltyPosCode {
  code: string;
  expiresAt: string;
  firstName: string;
  lastName: string | null;
  bonuses: number;
}

export interface LoyaltyCardData {
  id: string;
  firstName: string;
  lastName: string | null;
  phone: string;
  bonuses: number;
  discountPercent: number;
}

function errMsg(data: any, fallback: string): string {
  const m = data?.message;
  if (Array.isArray(m) && typeof m[0] === 'string') return m[0];
  if (typeof m === 'string' && m.trim()) return m.trim();
  return fallback;
}

export const loyaltyApi = {
  async getPolicy(): Promise<{ discountPercent: number }> {
    const res = await fetch(`${API_URL}/loyalty/policy`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(errMsg(data, 'Не удалось загрузить политику лояльности'));
    return { discountPercent: Number(data.discountPercent ?? 0) };
  },
  async issuePosCode(token: string): Promise<LoyaltyPosCode> {
    const res = await apiFetch(`${API_URL}/loyalty/pos-code`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(errMsg(data, 'Не удалось получить код'));
    return {
      code: data.code,
      expiresAt: data.expiresAt,
      firstName: data.firstName,
      lastName: data.lastName ?? null,
      bonuses: Number(data.bonuses ?? 0),
    };
  },

  async getCard(token: string): Promise<LoyaltyCardData> {
    const res = await apiFetch(`${API_URL}/loyalty/card`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(errMsg(data, 'Не удалось загрузить карту'));
    return {
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName ?? null,
      phone: data.phone,
      bonuses: Number(data.bonuses ?? 0),
      discountPercent: Number(data.discountPercent ?? 0),
    };
  },

  async telegramSession(initData: string): Promise<
    | { linked: true; token: string; user: LoyaltyCardData; botUsername: string | null }
    | { linked: false; firstName: string; lastName: string | null; botUsername: string | null }
  > {
    const res = await fetch(`${API_URL}/loyalty/telegram/session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ initData }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(errMsg(data, 'Не удалось войти через Telegram'));
    const botUsername = typeof data.botUsername === 'string' && data.botUsername ? data.botUsername : null;
    if (data.linked) {
      return { linked: true, token: data.token, user: data.user, botUsername };
    }
    return {
      linked: false,
      firstName: data.firstName ?? '',
      lastName: data.lastName ?? null,
      botUsername,
    };
  },

  async telegramPhoneLogin(body: {
    initData: string;
    phone: string;
    code: string;
    firstName?: string;
    lastName?: string;
  }): Promise<{ token: string; user: LoyaltyCardData; isNewUser: boolean }> {
    const res = await fetch(`${API_URL}/loyalty/telegram/phone-login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(errMsg(data, 'Не удалось войти'));
    return { token: data.token, user: data.user, isNewUser: !!data.isNewUser };
  },
};

